import type {
	EngagementPlatformPluginConfig,
	EngagementPlatformPluginOptions,
	CoordinationClient,
} from '@atlaskit/editor-plugin-engagement-platform/engagementPlatformPluginType';

const coordinationClient: CoordinationClient = {
	start: () => Promise.resolve(false),
	stop: () => Promise.resolve(false),
};

const editorEngagementPlatform: {
	config: EngagementPlatformPluginOptions;
} = {
	config: {
		coordinationClient,
	} satisfies EngagementPlatformPluginConfig,
};

export const useEditorEngagementPlatform = (): {
	config: EngagementPlatformPluginOptions;
} => editorEngagementPlatform;
